import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import RadioBttn from '../buttons/RadioBttn'
// import { formatName } from '../../../helpers'
// import { Link } from 'react-router-dom'

class AddPoll extends Component {
  constructor (props) {
    super(props)

    this.state = {
      title: '',
      message: '',
      pollType: '' // enum: ['yes-no', 'scaling', 'open']
    }

    this.submitForm = this.submitForm.bind(this)
    this.dismissPopup = this.dismissPopup.bind(this)
  }

  componentDidMount () {
    const { payload } = this.props

    this.setState({
      title: payload.title || '',
      message: payload.text || '',
      pollType: payload.pollType || ''
    })
  }

  dismissPopup () {
    this.props.dispatch(actions.switchAddPoll({}))
  }

  submitForm () {
    if (this.state.title === '') {
      this.props.dispatch(actions.displayAlert('Title is missing.'))
      return
    }

    if (this.state.pollType === '') {
      this.props.dispatch(actions.displayAlert('Please choose poll type.'))
      return
    }

    const { payload } = this.props
    const state = this.state

    let data = {
      title: state.title,
      text: state.message,
      type: 'poll',
      pollType: state.pollType
    }

    if (payload._id) {
      if (payload.title === state.title &&
        payload.text === state.message &&
        payload.pollType === state.pollType) {
        this.props.dispatch(actions.displayAlert('There is no change to save.'))
        return
      }

      this.props.dispatch(actions.socketSendMessage({ action: 'edit-comment', data: { ...payload, ...data } }))
      return
    }

    this.props.dispatch(actions.socketSendMessage({ action: 'new-comment-qapolls', data }))
  }

  render () {
    const editing = JSON.stringify(this.props.payload) !== '{}'
    const warning = editing && this.props.payload.pollType !== this.state.pollType

    return (
      <div className='dashboard-popup-notif'>
        <div className='hey-popup-header'>
          <h4 className='header-text'>{editing ? 'EDIT POLL' : 'CREATE POLL'}</h4>
          <button
            onClick={this.dismissPopup}
            className='black-cross'>
            <img alt='' src='/imgs/close.png' />
          </button>
        </div>
        <div className='line'>
          <div className='left'>
            <div> Title:</div>
          </div>
          <div className='center'>
            <input
              className='subject-input'
              value={this.state.title || ''}
              onChange={ev => this.setState({ title: ev.target.value })}
              type='text'
              placeholder='Title' />
          </div>
        </div>
        <div className='line'>
          <div className='left'>
            <div> Question:</div>
          </div>
        </div>
        <div className='pop-message-container fix-height'>
          <div className='dashboard-players2'>
            <div className='y-scroll-wrap2'>
              <div className='y-scroll2'>
                <div className='dashboard-players-list2'>
                  <div className='dashboard-players-row2'>
                    <textarea
                      className='message-input poll-textarea'
                      value={this.state.message || ''}
                      onChange={ev => this.setState({ message: ev.target.value })}
                      type='text'
                      placeholder='' />
                  </div>
                </div>
              </div>
            </div>
            <div className='poll-types'>
              <RadioBttn
                text='Yes - No answer'
                selected={this.state.pollType === 'yes-no'}
                onClick={() => this.setState({ pollType: 'yes-no' })}
                clickable
              />
              <RadioBttn
                text='Scaling answer'
                selected={this.state.pollType === 'scaling'}
                onClick={() => this.setState({ pollType: 'scaling' })}
                clickable
              />
              <RadioBttn
                text='Open answer'
                selected={this.state.pollType === 'open'}
                onClick={() => this.setState({ pollType: 'open' })}
                clickable
              />
            </div>
          </div>
          {warning &&
            <div>
              <span className='warning-message'>
                WARNING!
              </span> Changing answer type will result in deleting already given answers.
            </div>
          }
        </div>
        <div className='popup-button-cont'>
          <button
            onClick={this.submitForm}
            className='button-bt '>{editing ? 'Save changes' : 'Create poll'}</button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    payload: state.popup.payload
  }
}

export default connect(mapStateToProps)(AddPoll)



// WEBPACK FOOTER //
// ./src/components/common/popups/AddPoll.js